import { HTTP, ENDPOINT } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

// Crear un nuevo cliente
export const createClient = async (body) => {
    console.log(body);
    return await fetchFromLawfeed({
        method: HTTP.POST,
        endpoint: ENDPOINT.CREATE_CLIENT,
        body: body
    });
};